export class ItemSource {
  constructor(
    public id: string,
    public name: string,
    public image?: string,
  ) {}
}
